import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";
const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
});

// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 检查用户是否已登录
  //判断缓存在不在
  var data = {
    session_key: localStorage.getItem("session_key") || "",
    token: localStorage.getItem("token") || "",
    session_verify: localStorage.getItem("session_verify") || "",
  };
  // 获取查询参数
  const merchant_code: any = to.query.m;
  if (merchant_code != undefined) {
    localStorage.setItem("merchant_code", merchant_code);
  }
  const invite: any = to.query.i;
  if (invite != undefined) {
    localStorage.setItem("invite", invite);
  }
  if (data.session_key == "" && to.path != "/login/index" && to.path != "/localMaterial/phone_upload") {
    next("/login/index");
  } else {
    if (to.path == "/clipRule/index/0/0" && from.name == "clipRule") {
      const answer = window.confirm("请确保您已保存视频模型，如果您已保存请忽略。如果您未保存视频模型，请先保存！！！");
      if (answer) {
        next();
      } else {
        next(false);
      }
      return;
    } else {
      next();
    }
  }
});
export default router;
